const range = n => Array.from(Array(n), (_, i) => i)

export default range;